import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, withDefaults, onMounted } from 'vue';
  import SimpleModal from '@/components/common/SimpleModal.vue';
  import { useToasted } from '@/helpers';
  import { apiCreateFolder } from '@/api/content';

  
  const __default__ = {
    name: 'CreateContentFolderModal',
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    parentFolder: { type: [Number, null], required: false, default: null }
  },
  emits: ["close", "success"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'close', data: { shouldRehydrate: boolean }): void;
    (event: 'success', data: { shouldRehydrate: boolean }): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { parentFolder: number | null };

  
  const { parentFolder } = toRefs(props);

  

  const toasted = useToasted();

  const modalRef = ref(null);

  const folderName = ref('');
  const isLoading = ref(false);
  const shouldRehydrate = ref(false);

  onMounted(() => {
    if (modalRef.value) {
      modalRef.value.open();
    }
  });

  async function handleCreateFolder() {
    if (isLoading.value) return;

    if (folderName.value === null || folderName.value === '') {
      toasted.global.general_error({
        message: 'Content folder name cannot be empty',
      });
      return;
    }

    try {
      isLoading.value = true;
      shouldRehydrate.value = false;

      await apiCreateFolder(folderName.value, parentFolder.value);

      toasted.global.general_success({
        message: 'Created new content folder',
      });

      shouldRehydrate.value = true;
      emit('success', { shouldRehydrate: shouldRehydrate.value });

      if (modalRef.value) {
        modalRef.value.close();
      }
    } catch (error) {
      toasted.global.general_error({
        message: 'Failed to create new content folder',
      });

      shouldRehydrate.value = false;
    } finally {
      isLoading.value = false;
    }
  }

  function handleClose() {
    emit('close', { shouldRehydrate: shouldRehydrate.value });
  }

return { __sfc: true,props, parentFolder, emit, toasted, modalRef, folderName, isLoading, shouldRehydrate, handleCreateFolder, handleClose, SimpleModal }
}

})